
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
import Form from "./Pages/Form";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/login" element={<Form />}/>
      </Routes>
    </BrowserRouter>
  );
}
